import React, { useState } from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import axios from "axios";
import {
  Button,
  ModalFooter,
  Modal,
  Alert,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { EditChannel } from "./EditChannel";
import {
  settingActions,
  msgActions,
  loaderMaskActions,
} from "../../../../redux/actions";
import { handleErrors } from "../../../../utils";

const Channels = ({
  user,
  subUser,
  isSubUser,
  userLDAPUserRights,
  channels,
  translate,
  dispatch,
}) => {
  const [showEditChannel, setShowEditChannel] = useState(false);
  const [editChannelModalHeader, setEditChannelModalHeader] = useState("");
  const [channelInitialValues, setChannelInitialValues] = useState({});
  const [addNewChannel, setAddNewChannel] = useState(false);
  const [confirmDeleteChannelModal, setConfirmDeleteChannelModal] =
    useState(false);
  const [channelToRemove, setChannelToRemove] = useState(null);

  const handleAddNewChannel = () => {
    setShowEditChannel(true);
    setAddNewChannel(true);
    setChannelInitialValues({});
    setEditChannelModalHeader(translate("Add New Channel"));
  };
  const editChannel = (item) => {
    setShowEditChannel(true);
    setAddNewChannel(false);
    setChannelInitialValues({
      ...item,
    });
    setEditChannelModalHeader(translate("Edit Channel"));
  };

  const toggleEditChannelModal = () => setShowEditChannel(!showEditChannel);

  const handleEditChannelSubmit = async (values) => {
    var currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    const { userId, timeZone } = currentUser || {};
    let ChannelMappingData = {};
    if (!addNewChannel) {
      // Updating
      ChannelMappingData = {
        ...values,
        _id: channelInitialValues?._id,
      };
    } else {
      ChannelMappingData = { ...values };
    }
    var params = {
      TimeZone: timeZone,
      Username: userId,
      ChannelMappingData,
    };
    try {
      dispatch(loaderMaskActions.show("Updating channels..."));
      let data = await updateChannel(params);
      dispatch(loaderMaskActions.hide(""));
      var _channels = channels.slice(0);
      var _index = _channels.findIndex(({ _id }) => _id === data._id);
      if (_index === -1) {
        _channels.push(data);
      } else {
        _channels[_index] = data;
      }
      dispatch(settingActions.updateChannelList(_channels));
      dispatch(
        msgActions.success("Updating channels", "Channels updated successfully")
      );
      toggleEditChannelModal();
    } catch (error) {
      dispatch(loaderMaskActions.hide(""));
      handleErrors(error, dispatch, "Updating channels");
    }
  };

  const updateChannel = async (params) => {
    let res = await axios.post("Configuration/channels/addUpdate", params);
    let { Data, Errors } = res.data;
    if (Errors && Errors.length) {
      return Promise.reject(Errors[0]);
    }
    if (typeof Data === "object") {
      return Promise.resolve(Data);
    }
    return Promise.reject("Unknown Error");
  };

  const handleRemoveChannel = (channel) => {
    setConfirmDeleteChannelModal(true);
    setChannelToRemove(channel);
  };

  const toggleConfirmDeleteChannelModal = () =>
    setConfirmDeleteChannelModal(!confirmDeleteChannelModal);

  const handleYesConfirmDeleteChannel = async () => {
    try {
      dispatch(loaderMaskActions.show("Deleting channels..."));
      await performDeleteChannel({ Id: channelToRemove._id });
      dispatch(loaderMaskActions.hide(""));
      var _channels = channels.slice(0);
      var _index = _channels.findIndex(
        ({ _id }) => _id === channelToRemove._id
      );
      if (_index > -1) {
        _channels.splice(_index, 1);
      }
      dispatch(settingActions.updateChannelList(_channels));
      dispatch(
        msgActions.success("Deleting channels", "Channels updated successfully")
      );
      toggleConfirmDeleteChannelModal();
    } catch (error) {
      dispatch(loaderMaskActions.hide(""));
      handleErrors(error, dispatch, "Deleting channels");
    }
  };

  const performDeleteChannel = async (params) => {
    let res = await axios.delete("Configuration/channels/delete", { params });
    let { Data, Errors } = res.data;
    if (Errors && Errors.length) {
      return Promise.reject(Errors[0]);
    }
    if (Data) {
      return Promise.resolve(Data);
    }
    return Promise.reject("Unknown Error");
  };

  const generateChannelGrid = (channels) => {
    return (
      <table className="table" style={{ display: "table" }}>
        <thead>
          <tr>
            <th>Channel name</th>
            <th>External name</th>
            <th>Color</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {(channels || []).map((item, index) =>
            item.NotChannel ? null : (
              <tr key={item._id}>
                <td>{item.ChannelName}</td>
                <td>{item.ToChannelName}</td>
                <td>
                  <div
                    className="color-rec-container"
                    style={{
                      background: `${item.ColorHex}`,
                    }}
                  />
                </td>
                <td style={{ display: "flex" }}>
                  <button
                    disabled={
                      !(userLDAPUserRights && userLDAPUserRights.IsNTTAdmin)
                    }
                    style={{ padding: "0 5px" }}
                    className="add-issue-btn"
                    onClick={() => editChannel(item)}
                  >
                    <i className="fa fa-edit" />
                  </button>
                  <button
                    disabled={
                      !(userLDAPUserRights && userLDAPUserRights.IsNTTAdmin)
                    }
                    style={{ padding: "0 5px" }}
                    className="add-issue-btn"
                    onClick={() => handleRemoveChannel(item)}
                  >
                    <i className="fa fa-times" />
                  </button>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    );
  };
  return (
    <>
      <div className="channel-container">
        <div className="row flex-nowrap justify-content-between align-items-center">
          <div className="col-4">
            <strong>{translate("Channels")}</strong>
          </div>
          <div className="col-4 d-flex justify-content-end align-items-center">
            <Button
              disabled={!(userLDAPUserRights && userLDAPUserRights.IsNTTAdmin)}
              color="primary"
              size="sm"
              onClick={handleAddNewChannel}
            >
              <span className="fa fa-plus" />
            </Button>
          </div>
        </div>
        <div className="channel-grid">{generateChannelGrid(channels)}</div>
      </div>
      <EditChannel
        isOpen={showEditChannel}
        toggleModal={toggleEditChannelModal}
        modalHeader={editChannelModalHeader}
        initialValues={{ ...channelInitialValues }}
        handleSubmit={handleEditChannelSubmit}
      />
      <Modal
        isOpen={confirmDeleteChannelModal}
        toggle={toggleConfirmDeleteChannelModal}
      >
        <ModalHeader toggle={toggleConfirmDeleteChannelModal}>
          Remove Channel
        </ModalHeader>
        <ModalBody>
          <Alert color="danger">{translate("DeleteChannelConfirm")}</Alert>
        </ModalBody>
        <ModalFooter className="text-center">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={toggleConfirmDeleteChannelModal}
          >
            Cancel
          </button>
          <Button
            color="primary"
            className="EventSearchSubmit"
            style={{ marginLeft: "20px" }}
            onClick={handleYesConfirmDeleteChannel}
          >
            Remove
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

function mapStateToProps(state) {
  const {
    settings: { channels },
    locale,
    authentication,
  } = state;
  const { user, subUser, isSubUser, isSender, userLDAPUserRights } =
    authentication;
  return {
    user,
    subUser,
    isSubUser,
    isSender,
    userLDAPUserRights,
    channels,
    translate: getTranslate(locale),
  };
}

const connectedChannels = connect(mapStateToProps)(Channels);
export { connectedChannels as Channels };
